module.exports = "https://coursera_assets.s3.amazonaws.com/images/2162f57c676ee75a55bc906dc48cba75.png";